module.exports = __webpack_public_path__ + "static/media/OpenSans-SemiBold.096d8c73.ttf";